module.exports = __webpack_public_path__ + "static/img/butterfly-p.54db474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/butterfly-p.png
// module id = q6nf
// module chunks = 1